import { useEffect } from 'react';

import { useThemeContext } from 'context/ThemeContext';
import GenericPageLayout, {
  GenericPageLayoutProps,
} from 'components/general/genericPageLayout/GenericPageLayout';
import CustomMetaData, {
  CustomMetaDataProps,
} from 'components/general/customMetaData/CustomMetaData';
import { CareerList, CareerListType } from 'components/careerList/CareerList';
import { BlocksMediaType, MediaBlock } from 'components/general/mediaBlock/MediaBlock';
import { NEXTJS_REVALIDATE_PAGE_IN_SECONDS } from 'pages/index';
import { getEndpoint } from 'utils/helpers';
import { parseGenericPage } from 'utils/parsers';

import blockStyle from 'components/general/standardBlocksLayout/StandardBlocksLayout.module.scss';
import style from './contactPage.module.scss';

type Props = {
  generic: GenericPageLayoutProps;
  metaData: CustomMetaDataProps;
  positionsImage: BlocksMediaType;
  careerList: CareerListType;
  noOpenPositionsMessage: string;
};

const Contact = (props: Props) => {
  const { setTheme } = useThemeContext();

  useEffect(() => {
    setTheme('light');
  }, [setTheme]);

  // const { setGlobalData } = useGlobalDataContext();
  // setGlobalData(props.globalData);

  return (
    <GenericPageLayout {...props.generic} blockStyles={blockStyle.aboutBlocks}>
      <CustomMetaData {...props.metaData} />
      <div>
        <section className={style.content}>
          <div className={style.image}>
            <MediaBlock {...props.positionsImage} block_type={'media'} />
          </div>
          <section className={style.careers}>
            {props.careerList.list && props.careerList.list.length ? (
              <CareerList list={props.careerList.list} />
            ) : (
              <div className={style.noOpenings} dangerouslySetInnerHTML={{__html: props.noOpenPositionsMessage}} />
            )}
          </section>
        </section>
      </div>
    </GenericPageLayout>
  );
};

export async function getStaticProps(context) {
  const genericProps: GenericPageLayoutProps = await parseGenericPage('/contact-page/', context);
  const positions = await getEndpoint('/positions/', context);

  // Pass data to the page via props

  const props: Props = {
    generic: genericProps,
    metaData: {
      titleDefault: genericProps.originalResponse.title,
      title: genericProps.originalResponse.meta_title,
      description: genericProps.originalResponse.meta_description,
      image: genericProps.originalResponse.meta_image,
    },
    positionsImage: genericProps.originalResponse.positions_image,
    careerList: {
      list: positions,
    },
    noOpenPositionsMessage: genericProps.originalResponse.no_open_positions_message
  };
  return {
    props,
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: NEXTJS_REVALIDATE_PAGE_IN_SECONDS, // In seconds
  };
}

export default Contact;
